import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import Text from '../components/Text'

const ButtonElt = styled.button`
  display: block;
  background: var(--${props => props.disabled ? 'gray' : props.color});
  color: #fff;
  padding: 0.75rem 1.25rem;
  cursor: ${props => props.disabled ? 'default' : 'pointer'};
  transition: all 0.2s;
  font-weight: 300;
  border-radius: 1.25rem;
  width: 100%;
  &:hover {
    box-shadow: ${props => props.disabled ? 'none' : `0 0 5px var(--${props.color})`};
  }
`

class Button extends Component {
  render() {
    const {
      str,
      type = 'button',
      history,
      to,
      href,
      children,
      newWindow,
      ...props
    } = this.props

    if (to) {
      return (
        <ButtonElt
          type="button"
          onClick={newWindow ? () => window.open(to, "_blank") : () => history.push(to)}
          {...props}
        >
          {str && <Text str={str} />}
          {!str && children}
        </ButtonElt>
      )
    }

    return (
      <ButtonElt type={type} {...props}>
        {str && <Text str={str} />}
        {!str && children}
      </ButtonElt>
    )
  }
}

export default withRouter(Button)



// WEBPACK FOOTER //
// ./src/components/Button.js